import { defineStore } from 'pinia'

export const useSessionStore = defineStore("session", {
  persist: {
    storage: persistedState.cookies,
  },
  state: () => {
    return {
      token: null,
      expires_at: null,
      lead_id: null,
    }
  },
  actions: {
    async fetchToken() {
      if (this.token && this.expires_at && this.expires_at.getTime() > new Date().getTime()) {
        return
      }

      const config = useRuntimeConfig();

      await $fetch(config.public.apiBaseUrl + 'oauth/token', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          grant_type: 'client_credentials',
          client_id: config.public.apiClientId,
          client_secret: config.public.apiClientSecret,
        }),
      }).then((data) => {
          this.token = data.access_token
          this.expires_at = new Date().setSeconds(new Date().getSeconds + data.expires_in)
      })
    }
  },
});
